import { 
  MdTitle,
} from "react-icons/md";
import { FormData, SetFormData } from './FormData.tsx';
import { useEffect } from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Bold from '@tiptap/extension-bold';
import Italic from '@tiptap/extension-italic';
import Heading from '@tiptap/extension-heading';
import BulletList from '@tiptap/extension-bullet-list';
import OrderedList from '@tiptap/extension-ordered-list';

interface listingForm {
  formData: FormData;
  setFormData: SetFormData;
  setNextDisabled: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function WorkspaceTitleAndDescription({ formData, setFormData, setNextDisabled }: listingForm) {
  const editor = useEditor({
    extensions: [
      StarterKit,
      Bold,
      Italic,
      Heading.configure({
        levels: [2, 3],
      }),
      BulletList,
      OrderedList,
    ],
    content: formData.description || '',
    onUpdate: ({ editor }) => {
      const html = editor.getHTML();
      setFormData({ ...formData, description: html });
      setNextDisabled(!editor.getText().trim());
    },
  });
  
  const handleInputChange = (field: keyof FormData, value: string | number | boolean) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    if(!formData.isFurnished) {
      setFormData(prev => ({...prev, desks: 0, chairs: 0 }));
    }
  };

  useEffect(() => {
      if (formData.title.length === 0 && formData.description.length === 0) {
        setNextDisabled(true);
      } else {
        setNextDisabled(false);
      }
    }, [formData.title, formData.description]);

  useEffect(() => {
    if (editor && formData.description) {
      editor.commands.setContent(formData.description);
    }
  }, [editor]);
  return (
    <div className="space-y-4">
      <h2 className="text-3xl font-bold mb-4">Make Your Space Shine! Add a Title & Description</h2>
      <hr className="border-t border-gray-500 my-4 w-full shadow-gray-400" />
      <div className='flex flex-col sm:flex-row sm:flex-wrap gap-4'></div>
      {/* Title Input */}
      <div className="p-4 border border-gray-200 rounded-lg">
        <div className="flex items-center gap-3 mb-3">
          <MdTitle className="h-6 w-6 text-gray-500" /> 
          <h3 className="text-lg font-medium">Title</h3> 
        </div>
        <input
          type="text"
          value={formData.title || ''} 
          onChange={(e) => handleInputChange('title', e.target.value)} 
          className="w-full p-2 border rounded"
          placeholder="Enter workspace title" 
          maxLength={150} 
        />
      </div>

      {/* Description Input */}
      <div className="space-y-6">
        <h2 className="text-2xl font-bold text-gray-900">What best describes your workspace?</h2>
        
        <div className="flex gap-2 text-sm text-gray-500">
          <span>Formatting</span>
          <button 
            onClick={() => editor!.chain().focus().toggleBold().run()}
            className={`px-2 rounded ${editor?.isActive('bold') ? 'bg-gray-200' : ''}`}
          >
            Bold
          </button>
          <button 
            onClick={() => editor!.chain().focus().toggleItalic().run()}
            className={`px-2 rounded ${editor?.isActive('italic') ? 'bg-gray-200' : ''}`}
          >
            Italic
          </button>
        </div>
        <div className="border border-gray-200 rounded-lg overflow-hidden">
          <EditorContent 
            editor={editor} 
            className="min-h-[250px] p-4 focus:outline-none" 
          />
        </div>
        
        {/* AI Feature */}
      </div>
      
    </div>
  );
}